import { type FormikErrors, type FormikValues } from "formik"

export function getErrorPaths<TFormValues extends FormikValues>(
    formErrors: FormikErrors<TFormValues>
) {
    let paths: string[] = []

    Object.entries(formErrors).forEach(([key, value]) => {
        if (typeof value === "string") {
            return paths.push(key)
        }

        const nestedErrorPaths = getErrorPaths(value).map((path) => `${key}.${path}`)
        paths = paths.concat(nestedErrorPaths)
    })

    return paths
}
